import { InvoiceHistoryTabView } from "../../../ar/src/InvoiceHistoryTabView";
import { MovementTabView } from "../../../dispatch/src/MovementTabView";
import { EdiBilling } from "../EdiBilling";
import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutViewEdiBillingDetail extends Layout {
    layoutEdiBilling: EdiBilling;
    layoutInvoiceHistoryTabView: InvoiceHistoryTabView;
    layoutMovementTabView: MovementTabView;
}
